export enum SalesReturnReasons
 {
     Injury_Health_Concerns = 1,
     Equipment_Malfunction = 2,
     Facility_Cleanliness_Maintenance = 3,
     Cancellation_Membership = 4,
     Unsatisfactory_Results = 5,
     Payment_Disputes = 6,
     Relocation = 7,
     Other = 13
 }

 export enum RefundStatus
 {
     Initiated = 1,
     Refunded = 2,
     Failed = 3,
     Void=4
 }

 export enum RefundReason
 {
     Injury_Health_Concerns = 1,
     Equipment_Malfunction = 2,
     Facility_Cleanliness_Maintenance = 3,
     Cancellation_Membership = 4,
     Unsatisfactory_Results = 5,
     Payment_Disputes = 6,
     Relocation = 7,
     Defective_Product = 8,
     Wrong_Product_Received = 9,
     Product_Quality_Concerns = 10,
     Expired_Product = 11,
     Product_Doent_Meet_Expectations = 12,
     Other = 13
 }

export enum RefundMode
{
    Online = 1,
    Offline = 2,
    Device = 3,
    Credit = 4,
}